import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledProjectLayout = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 16px;
  padding: 32px;
  background-color: ${COLOR.white};
  margin: 16px 0;
`;

export const StyledProjectHeader = styled('div')`
  border-bottom: 1px solid #3c3c4329;

  .title-wrapper {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 24px;
  }

  .title {
    font-weight: 700;
    font-size: 32px;
    line-height: 38px;
    letter-spacing: -0.4px;
    color: #1c1c1e;
    vertical-align: middle;
  }

  .content {
    font-weight: 400;
    font-size: 14px;
    color: ${COLOR.label[80]};
    line-height: 20px;
    letter-spacing: -0.4px;
  }
`;
